import { OVERLAY_Z_INDEX_CEILING } from "./eva-z-layers";

export interface EvaModalLayer {
  currentZIndex: number;
  closeFromEscape(): void;
}

const EVA_MODAL_BASE_Z_INDEX = 11000;

// Modales seulement : compter les dropdowns ouverts ferait passer les suivants sous la dialog.
const OTHER_MODALS_SELECTOR = ".p-dialog-mask, .p-sidebar";

const openModals: EvaModalLayer[] = [];

let escapeListenerInstalled = false;

// Sur <body> : passe avant les écouteurs document (p-sidebar, drawer) qui fermeraient le dessous.
function installEscapeListener(doc: Document): void {
  if (escapeListenerInstalled) return;
  escapeListenerInstalled = true;
  doc.body.addEventListener("keydown", (event: KeyboardEvent) => {
    if (event.key !== "Escape" || !openModals.length) return;
    event.stopPropagation();
    if (event.defaultPrevented) return;
    event.preventDefault();
    openModals[openModals.length - 1].closeFromEscape();
  });
}

export function registerModal(layer: EvaModalLayer, doc: Document): void {
  installEscapeListener(doc);
  openModals.push(layer);
}

export function unregisterModal(layer: EvaModalLayer): void {
  const index = openModals.indexOf(layer);
  if (index !== -1) openModals.splice(index, 1);
}

/** Vrai si une eva-dialog ou un eva-drawer est ouvert : les autres écouteurs d'Escape doivent le laisser gérer. */
export function hasOpenEvaModal(): boolean {
  return openModals.length > 0;
}

/** Retourne un z-index au-dessus des modales ouvertes (eva-dialog, eva-drawer, p-sidebar). */
export function nextModalZIndex(layer: EvaModalLayer, host: HTMLElement, doc: Document): number {
  let maxZIndex = EVA_MODAL_BASE_Z_INDEX;

  openModals.forEach((other) => {
    if (other !== layer) maxZIndex = Math.max(maxZIndex, other.currentZIndex);
  });

  doc.querySelectorAll<HTMLElement>(OTHER_MODALS_SELECTOR).forEach((element) => {
    if (host.contains(element)) return;

    const zIndex = Number.parseInt(window.getComputedStyle(element).zIndex, 10);
    if (!Number.isNaN(zIndex) && zIndex > maxZIndex && zIndex < OVERLAY_Z_INDEX_CEILING) {
      maxZIndex = zIndex;
    }
  });

  return maxZIndex + 1;
}
